import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EnergyBaseCalculation } from '@eadsysteme/energyefficiencyclient-v2';
import { DateUtil } from '../../../../util/DateUtil';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { NumberUtil } from '../../../../util/NumberUtil';
import { TranslocoLocaleService } from '@jsverse/transloco-locale';
import { FormulaUtilService } from '../../../../services/FormulaUtil.service';
import { OrdinaryAllocationType, PhysicalUnit } from '@eadsysteme/billingclient-v1';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'vex-reading-value-info-dialog',
	templateUrl: './reading-value-info-dialog.component.html',
	styleUrls: ['./reading-value-info-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslocoDirective, MatButton, MatIcon],
})
export class ReadingValueInfoDialogComponent {
	dialogRef = inject<MatDialogRef<ReadingValueInfoDialogComponent>>(MatDialogRef);
	numberUtil = inject(NumberUtil);
	dateUtil = inject(DateUtil);
	private transloco = inject(TranslocoService);
	private translocoLocale = inject(TranslocoLocaleService);
	formulaUtil = inject(FormulaUtilService);

	public energyBaseCalculation: EnergyBaseCalculation;
	protected deviceType: string;
	protected deviceNumber: string;
	protected costType: OrdinaryAllocationType;
	private readonly locale: string;

	constructor() {
		const data = inject<[EnergyBaseCalculation, string, string, OrdinaryAllocationType]>(MAT_DIALOG_DATA);

		this.energyBaseCalculation = data[0];
		this.deviceType = data[1];
		this.deviceNumber = data[2];
		this.costType = data[3];
		this.locale = this.translocoLocale.getLocale();
		this.numberUtil._locale = this.locale;
	}

	close() {
		this.dialogRef.close();
	}

	protected readonly PhysicalUnit = PhysicalUnit;
	protected readonly OrdinaryAllocationType = OrdinaryAllocationType;
}
